export const attachPolylineTapEvent = (polyline, feature, onTourLineClick) => {
  polyline.addEventListener('tap', (evt) => {
    evt.stopPropagation();
    onTourLineClick(feature);
  });
};

export const attachPolylineContextMenuEvent = (polyline, feature, onToggleHiddenSegment) => {
  polyline.addEventListener('contextmenu', (evt) => {
    evt.stopPropagation();
    onToggleHiddenSegment(feature);
  });
};

